import { useCallback } from "react"
import { useNavigate, useParams } from "react-router"
import styled from "@emotion/styled"
import { ConfirmLayout } from "@/templates/ConfirmLayout"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { theme } from "@/theme"
import { useBackgroundFetchCtx } from "@/hooks/useBackgroundFetch"
import { useMobileLayoutProps } from "@/hooks/useMobileLayoutProps"
import { useTranslation } from "@/hooks/useTranslation"

const Styled = {
    Body: styled.div`
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
    PageTitle: styled.div`
        font-size: 20px;
        font-weight: bold;
        color: ${theme.palette.intentions.text.primary};
        margin: 2em;
    `
}

const WaitingUploadPage = () => {
    const { t } = useTranslation()
    const { rootProps, bodyProps } = useMobileLayoutProps()

    return (
        <main {...rootProps}>
            <Styled.Body {...bodyProps}>
                <Styled.PageTitle>
                    {t("すべての写真の送信完了までお待ち下さい…")}
                </Styled.PageTitle>
            </Styled.Body>
        </main>
    )
}

export const FinishPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { cleaningId } = useParams<"cleaningId">()
    assertIsDefined(cleaningId)
    const { inProgress } = useBackgroundFetchCtx()

    const gotoSchedule = useCallback(() => {
        navigate("/schedule")
    }, [navigate])

    if (inProgress) {
        return <WaitingUploadPage />
    }

    return (
        <ConfirmLayout
            title={t("報告は以上です！")}
            titleSecondLine={t("お疲れ様でした！")}
            sealImageSrc="/assets/azarashi/az_rfU_lfD_reF_leC.png"
            primaryButtonLabel={t("閉じる")}
            next={gotoSchedule}
        />
    )
}
